import { render, staticRenderFns } from "./parametrizationBrokerAndInsuranceCarrier.vue?vue&type=template&id=09f31468&"
import script from "./parametrizationBrokerAndInsuranceCarrier.vue?vue&type=script&lang=js&"
export * from "./parametrizationBrokerAndInsuranceCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports